<template>
  <base-container
    :title="`Starred ${docType}`"
    :view-link="`/documents/${docType}`"
    :with-gradient="policies.length > 1"
    header-central
    no-padding
  >
    <base-scroll-list>
      <ol v-if="policies.length > 0" role="list">
        <li v-for="(article, index) in policies" :key="index" role="listitem">
          <div
            class="preview-card row"
            @click="rowClicked(article)"
            @keyup.enter="rowClicked(article)"
            role="article"
            tabindex="0"
          >
            <div class="image col-xs-12 col-md-2">
              <file-icon
                v-if="
                  article.current_version &&
                    article.current_version.file &&
                    !article.current_version.external_url
                "
                :type="article.current_version.file.name | extension"
              ></file-icon>
              <file-icon
                v-else-if="article.current_version.external_url"
                type="link"
              />
              <file-icon v-else type="file"></file-icon>
            </div>
            <div class="content col-xs-12 col-md-10">
              <p>
                <strong>{{ article.current_version.title }}</strong>
              </p>
            </div>
          </div>
        </li>
      </ol>
      <p v-else role="article">You have no starred {{ docType }}</p>
    </base-scroll-list>
  </base-container>
</template>

<script>
/**
 * # Dashboard news widget
 * ---
 * A widget to display news relevant to the user, as well as news items tagged against user group 13 (MFT Trust)
 *
 */
import {
  BaseContainer,
  BaseScrollableList as BaseScrollList,
} from "@/components/Containers";

const CardList = () => import("@/components/Containers/BaseCardList");

export default {
  name: "PoliciesWidget",
  components: {
    BaseContainer,
    BaseScrollList,
    CardList,
  },

  data() {
    return {
      postLimit: 1,
      policies: [],
    };
  },

  props: {
    limit: {
      type: [Number, String],
      default: 10,
    },
    docType: {
      type: String,
      default: "policies",
    },
  },

  /**
   * When mounted we need to get the news items.  We also need to read the users interest group id's
   * TODO: Should these be put in state or just read from the user object
   */
  async mounted() {
    await this.$store.dispatch("widgets/policies/setLimit", this.limit);
    this.$store
      .dispatch("widgets/policies/getDocuments", {
        limit: this.limit,
        docType: this.docType,
      })
      .then((resp) => {
        this.policies = resp.slice(0,this.limit);
      });
  },

  methods: {
    rowClicked(dataItem) {
      if (dataItem.policy_id) {
        this.$router.push({
          name: "DocumentVersionPreview",
          params: { id: dataItem.policy_id, versionId: dataItem.id },
        });
      } else if (dataItem.form_id) {
        this.$router.push({
          name: "DocumentVersionPreview",
          params: { id: dataItem.form_id, versionId: dataItem.id },
        });
      } else {
        this.$router.push({
          name: "DocumentPreview",
          params: { id: dataItem.id, docType: "policies" },
        });
      }
    },
  },

  watch: {
    limit: {
      immediate: false,
      deep: false,
      handler(newValue, oldValue) {
        this.postLimit = newValue;
        this.$store
          .dispatch("widgets/policies/setLimit", this.postLimit)
          .then(() => {
            this.$store.dispatch("widgets/policies/clearCache").then(() => {
              this.$store
                .dispatch("widgets/policies/getDocuments", {
                  limit: this.postLimit,
                  docType: this.docType,
                })
                .then((resp) => {
                  this.policies = resp.slice(0,this.limit);
                });
            });
          });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  border-bottom: 1px solid $colour-nhs-pale-grey;
  cursor: pointer;
  padding-bottom: 0.5rem;

  & + li {
    padding-top: 0.5rem;
  }
}

ol > * {
  transition: all ease-in-out 0.1s;
}

ol:hover > * {
  opacity: 0.6;
}

ol:hover > *:hover {
  opacity: 1;
}
</style>
